import Toolbar from '@mui/material/Toolbar';
import MuiAppBar from '@mui/material/AppBar';
import Stack from '@mui/material/Stack';
import { DRAWER_WIDTH, APP_BAR_HEIGHT } from '../index';
import AccountMenu from './AccountMenu';
import NotificationBar from './NotficationBar';

const Appbar = () => (
  <MuiAppBar
    position="fixed"
    sx={{
      width: `calc(100% - ${DRAWER_WIDTH}px)`,
      height: APP_BAR_HEIGHT,
      ml: `${DRAWER_WIDTH}px`,
      boxShadow: '0px 1px 2px 0px rgba(100, 116, 139, 0.1)',
      bgcolor: 'background.default',
    }}>
    <Toolbar
      sx={{
        width: '100%',
        padding: '12px 24px',
        justifyContent: 'end',
      }}>
      <Stack direction="row" spacing={1}>
        <NotificationBar />
        <AccountMenu />
      </Stack>
    </Toolbar>
  </MuiAppBar>
);

export default Appbar;
